
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/date-pickers/single-input-time-range-field",
      function () {
        return require("private-next-pages/x/api/date-pickers/single-input-time-range-field.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/date-pickers/single-input-time-range-field"])
      });
    }
  